import React from 'react';
import './App.css';
import MiniDrawer from './components/navComponent/sideNav';
import { ContentProvider } from './components/learn/contentContext';


const App: React.FC = () => {
  return (
    <ContentProvider>
       <MiniDrawer/>
    </ContentProvider>
  );
}

export default App;
